import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function Tooltip(props) {
  return (
    <>
      <div className={style.tooltip}>
        <div className={style.tooltip_top}>
          <h6>Heat Block</h6>
        </div>
        <div className={style.tooltip_bottom}>
          <h6>{props.filledSlots}/8 slots filled</h6>
        </div>
      </div>
    </>
  );
}

Tooltip.propTypes = {
  /**
   * Filled slots is a interger which stores how many tubes are filled in heatblock
   */
  filledSlots: PropTypes.number,
};
